import React from "react";
import { Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { CategoryIcon } from "./CategoryIcon";
import { QuestionItem } from "./QuestionItem";
import { GroupedQuestion } from "./types";

type SingleCategoryViewProps = {
  categoryData: GroupedQuestion;
  onClose: () => void;
  onSelectQuestion: (question: string) => void;
};

export const SingleCategoryView = ({
  categoryData,
  onClose,
  onSelectQuestion,
}: SingleCategoryViewProps) => (
  <div className="w-full bg-white rounded-lg border border-gray-200 shadow-lg mt-6 overflow-scroll hide-scrollbar">
    <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200">
      <h2 className="text-sm font-semibold text-[#064C68] flex items-center gap-3">
        <CategoryIcon category={categoryData.key} />
        {categoryData.key.toUpperCase()}
      </h2>
      <Button
        onClick={onClose}
        className="p-1 text-[#000000d9] transition-colors border-0 shadow-none"
        icon={<CloseOutlined />}
        aria-label="Close category view"
      />
    </div>
    <div className="p-4">
      <div className="space-y-3">
        {categoryData.values.map((question) => (
          <QuestionItem
            key={question.id}
            question={question}
            onSelect={onSelectQuestion}
            className="w-full text-left p-3 bg-[#00000005] rounded-lg border border-[#0000001f] hover:bg-[#00000008] transition-colors cursor-pointer"
          />
        ))}
      </div>
    </div>
  </div>
);
